export default {"src":"/_next/static/media/networking.51a3d311.svg","height":75,"width":73};